module.exports = __webpack_public_path__ + "img/jjtg_lct@2x.cd96e43e.png";